import React from 'react';
import { Typography } from '@vtblife/uikit';
import { TypographyProps } from '@vtblife/uikit/dist/components/typography/types';

import { generateDetailPrice, IGenDetailPrice } from './generateDetailPrice';

interface IProps extends IGenDetailPrice, Pick<TypographyProps, 'variant' | 'color' | 'bold'> {}

const PriceDetail: React.FC<IProps> = ({
    priceValue,
    priceCurrency,
    totalAreaUnit,
    totalAreaValue,
    short,
    color = 'black-250',
    variant = 'primary',
    bold
}) => {
    if (! priceValue || ! priceCurrency) {
        return null;
    }

    const priceText = generateDetailPrice({
        priceValue,
        priceCurrency,
        totalAreaUnit,
        totalAreaValue,
        short
    });

    return (
        <Typography color={color} variant={variant} bold={bold}>
            {priceText}
        </Typography>
    );
};

export default PriceDetail;
